/**
 * TrashIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const TrashIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M5.393 23q-.851 0-1.448-.594a1.96 1.96 0 0 1-.597-1.441V4.06h-.33a.98.98 0 0 1-.724-.295A1 1 0 0 1 2 3.037q0-.434.294-.723a1 1 0 0 1 .725-.29H7.93q0-.438.294-.73A1 1 0 0 1 8.95 1h6.095q.43 0 .725.297.293.298.293.728h4.92q.431 0 .724.295.294.294.294.728 0 .433-.294.722a1 1 0 0 1-.725.29h-.329v16.905q0 .847-.597 1.44-.596.595-1.448.595zM18.607 4.06H5.393v16.905h13.214zM8.527 18.453h1.916V6.535H8.527zm5.03 0h1.923V6.535h-1.923z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const TrashIcon = makeIcon('TrashIcon', TrashIconSvg)
